import {put, takeLatest, call} from 'redux-saga/effects'
import * as venueService from "../../../services/venueService"
import {
    CONTROL_VENUE_STATUSES,
    CONTROL_VENUE_STATUSES_SUCCESS,
    CONTROL_VENUE_STATUSES_ERROR,
}
    from "../../actions/venue";

function* controlVenueStatusesSaga(action) {
    try {
        const data  = yield call(venueService.ControlVenueStatuses ,action.payload)
        yield put({
         type: CONTROL_VENUE_STATUSES_SUCCESS,
         payload: data
     });

    } catch (error) {
        yield put({
            type: CONTROL_VENUE_STATUSES_ERROR,error: error.data
        });
    }
}


export function* controlVenueStatusesSagaWatcher() {
    yield takeLatest(CONTROL_VENUE_STATUSES, controlVenueStatusesSaga);
}